export function parseToMoney (value) {
    if (!value) value = 0;
    if (typeof value == 'string' && value.includes('$')){
        return value;
    }else{
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP'}).format(value);
    }
}

// Formato compacto para la tabla del Dashboard y los ejes/tooltips de los
// charts: `$1,4M`, `$12M`, `$1,5K`, `$0`. Regla (Phil, 2026-10-08): el
// decimal aporta cuando la mantisa tiene UN dígito (`$1,4M` y `$1M` son dos
// números distintos) y sobra desde dos (`$12M`, no `$12,4M`): la idea es
// ganar espacio. Aplica igual en K, M y B (Steve). Se redondea a un decimal
// ANTES de elegir el sufijo y los decimales: `9,96M` da `10,0M` y se escribe
// `$10M`; `999.950` sube a `$1,0M` en vez de `$1000K`. Bajo 1K, entero sin
// sufijo (CLP no lleva decimales). Si en algún tab querés símbolo distinto
// (USD, EUR), abstraé el `$` a un parámetro — hoy todo el módulo es CLP.
const COMPACT_UNITS = [[1e9, "B"], [1e6, "M"], [1e3, "K"]];

export function parseToCompactMoney (value) {
    const v = Number(value || 0);
    const abs = Math.abs(v);
    const sign = v < 0 ? "-" : "";
    for (const [unit, suffix] of COMPACT_UNITS) {
        const tenths = Math.round((abs / unit) * 10) / 10;
        if (tenths < 1) continue;
        const mantissa = tenths >= 10 ? String(Math.round(tenths)) : tenths.toFixed(1).replace(".", ",");
        return `${sign}$${mantissa}${suffix}`;
    }
    return `${sign}$${Math.round(abs)}`;
}

export const configMoney = {
    decimal: ",",
    thousands: ".",
    prefix: "$ ",
    suffix: "",
    precision: 0,
    allowBlank: true,
}
